<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
    <div v-else class="">
      <Banner
        :background="info.image ? info.image.url : ''"
        :title="!pgLoading ? $t('app.volunteerRequest') : ''"
        :subtitle="!pgLoading ? $t('app.volunteerRequest') : ''"
      >
      </Banner>
  
      <section class="login-area grey-bg2 pt-50">
        <div class="container">
          <div class="row d-flex justify-content-center">
            <div
              class="login-section donation-form white-bg mb-30 wow fadeInUp2 animated"
              data-wow-delay=".1s"
              style="
                visibility: visible;
                animation-delay: 0.1s;
                animation-name: fadeInUp2;
              "
            >
              <div
                v-if="pgLoading"
                class="section-title text-left mb-50 webkit-animation webkit-100-500"
              ></div>
              <div
                v-if="!pgLoading"
                class="section-title text-left mb-50"
                :style="$i18n.locale == 'en' ? 'text-align: left !important' : ''"
              >
                <h6 class="text-center">
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                    <i class="fas fa-heart"></i>
                  </span>
                  {{  $t('app.volunteerRequest') }}
                </h6>
                <h4>{{ $t("app.enter_data_required") }}</h4>
              </div>
  
              <div class="row payment-inner">
                <form>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-area mb-30">
                        <input
                          type="text"
                          class="form-control"
                          v-model="row.name"
                          :placeholder="$t('app.name')"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="input-area mb-30">
                        <input
                          type="email"
                          class="form-control"
                          v-model="row.email"
                          :placeholder="$t('auth.email')"
                        />
                      </div>
                    </div>
                    <div class="col-12 mb-30">
                      <div class="input-area mb-30">
                        <select
                            v-model="row.type_id"
                            style="width: 100%"
                            class="form-control">

                            <option value="">{{ $t('app.choose_volunteer_type') }}</option>
                            
                            <option v-for="(type, index) in types"
                                :value="type.id"
                                :key="index">
                                {{ locale === 'ar' ? type.name_ar : type.name_en }}
                            </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12">
                    <div class="input-area mb-20">
                      <vue-tel-input
                        v-model="row.mobile"
                        :placeholder="$t('auth.mobile')"
                        :defaultCountry="'KW'"
                        v-on:country-changed="countryChanged"
                        style="
                          direction: ltr !important;
                          text-align: left !important;
                        "
                      >
                      </vue-tel-input>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="input-area mb-30">
                      <textarea
                        rows="10"
                        cols="30"
                        class="form-control"
                        v-model="row.note"
                        :placeholder="$t('app.notes')"
                      ></textarea>
                    </div>
                  </div>
  
                    <div class="col-xl-12">
                      <button
                        type="button"
                        @click="request()"
                        :disabled="btnLoading"
                        class="theme_btn theme_btn_bg"
                      >
                        <div v-if="btnLoading">
                          <div class="loader loader-xs loader-center"></div>
                        </div>
                        <div v-if="!btnLoading">
                          {{ $t("app.request") }} <span></span>
                        </div>
                      </button>
                    </div>
  
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import iziToast from "izitoast";
  import { VueTelInput } from "vue-tel-input";
  
  export default {
    name: "volunteerRequest",
    components: {
      Banner: () => import("@/components/Banner.vue"),
      VueTelInput,
    },
    data() {
      return {
        row: {
          type_id: "",
          name: "",
          email: "",
          ccode: "",
          mobile: "",
          note: "",
        },
        locale: "ar",
        btnLoading: false,
        pgLoading: true,
        info: "",
        types: [],
      };
    },
    mounted() {
      this.fetchVolunteerTypes();
    },
    created() {
      //
      if (localStorage.getItem("locale")) {
        this.locale = localStorage.getItem("locale");
      }
      this.fetchData();
      
    },
    methods: {
  
      //
      fetchData() {
        this.pgLoading = true;
        this.axios.defaults.headers.common = {
          "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        };
        const options = {
          url: window.baseURL + "/settings/16",
          method: "GET",
          data: {},
          params: {
            locale: this.locale,
          },
        };
        this.$axios(options)
          .then((res) => {
            this.pgLoading = false;
            this.info = res.data.info;
          })
          .catch(() => {})
          .finally(() => {});
      },
      //
      fetchVolunteerTypes() {
        this.pgLoading = true;
        this.axios.defaults.headers.common = {
          "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        };
        const options = {
          url: window.baseURL + "/volunteersRequests",
          method: "GET",
          data: {},
          params: {
            locale: this.locale,
          },
        };
        this.$axios(options)
          .then((res) => {
            this.pgLoading = false;
            this.types = res.data.rows;
          })
          .catch(() => {})
          .finally(() => {});
      },
  
      // onTypes: function() {
      //         this.fetchData();
              
      //       },

      // request
      request() {
        if (!this.row.name || !this.row.email || !this.row.mobile ) {
          alert(this.$t("app.allRequired"));
          return;
        }
        this.btnLoading = true;
        this.axios.defaults.headers.common = {
          "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        };
        const options = {
          url: window.baseURL + "/volunteersRequests",
          method: "POST",
          data: {
            type_id: this.row.type_id,
            name: this.row.name,
            email: this.row.email,
            mobile: this.row.ccode +this.row.mobile,
            note: this.row.note,
          },
        };
        this.$axios(options)
          .then((res) => {
            this.btnLoading = false;
            this.$router.push({ name: "home" });
          })
          .catch(() => {
            this.btnLoading = false;
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: this.$t("app.error_contact_us"),
            });
          });
      },
      countryChanged(country) {
      this.row.ccode = country.dialCode;
    },
    },
  };
  </script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
// <style src="vue-tel-input/dist/vue-tel-input.css"></style>;

<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}
.vue-tel-input {
  height: 50px;
}
.vue-tel-input .vti__dropdown {
  width: 70px !important;
}
.vue-tel-input .vti__dropdown-arrow {
  width: 50px !important;
  margin-top: -10px !important;
  position: static !important;
}
.vti__dropdown-list.below {
  z-index: 99 !important;
}
</style>

  
  